import { z } from 'zod';

const singleTagSchema = z
  .object({
    tag_id: z.number(),
    name: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
  })
  .strict();

export type Tag = z.infer<typeof singleTagSchema>;

export const tagServiceDataSchema = z.array(singleTagSchema);
